.slider {
	--height: 28px;
	--track-height: 4px;

	input[type="range"] {
		cursor: pointer;
		-webkit-appearance: none;
		appearance: none;
		background: transparent;
		width: 100%;
		position: relative;
	}

	::-webkit-slider-runnable-track {
		height: var(--track-height);
		border-left: 1px solid var(--color-card-main);
		border-right: 1px solid var(--color-card-main);
	}
	::-moz-range-track {
		height: var(--track-height);
		border-left: 1px solid var(--color-card-main);
		border-right: 1px solid var(--color-card-main);
	}

	::-webkit-slider-thumb {
		-webkit-appearance: none;
		appearance: none;

		height: var(--height);
		width: var(--height);
		border-radius: var(--height);

		background-color: var(--color-card-main);
		border: 10px solid var(--color-main);
		box-shadow: 0 0 0 2px var(--color-card-main);
	}
	::-moz-range-thumb {
		-webkit-appearance: none;
		appearance: none;

		height: var(--height);
		width: var(--height);
		border-radius: var(--height);

		background-color: var(--color-card-main);
		border: 10px solid var(--color-main);
		box-shadow: 0 0 0 2px var(--color-card-main);
	}

	::-webkit-slider-thumb {
		/* fix webkit centering */
		margin-top: calc(var(--track-height) / 2 - var(--height) / 2);
	}

	:focus::-webkit-slider-thumb {
		outline: 3px solid var(--color-main);
		outline-offset: 0.125rem;
		border: 10px solid var(--color-main);
	}
}
